import mutations from '@/store/modules/mobile/mobileCommonState/mobile.mutations';
import actions from '@/store/modules/mobile/mobileCommonState/mobile.actions';
import getters from '@/store/modules/mobile/mobileCommonState/mobile.getters';
import { CAPABILITY_MOBILE } from '@/utils/constants';
import { NAVTABS } from '@/utils/templates//mobile/mobile.constants';
export interface State {
  currentTab: string;
  capability: string;
  mobileServices: any[];
  mobileOSs: any[];
  mobileAppVersions: any[];
  currentMobileService: any;
  currentMobileOS: any;
  currentMobileAppVersion: any;
  allAndroidAppVersions: any[];
  allIOSAppVersions: any[];
}

const initialState: State = {
  currentTab: NAVTABS.MOBILE_KPIS_CRASHES_TAB,
  capability: CAPABILITY_MOBILE,
  mobileServices: [],
  mobileOSs: [],
  mobileAppVersions: [],
  currentMobileService: {},
  currentMobileOS: {},
  currentMobileAppVersion: { key: 'all', label: 'All' },
  allAndroidAppVersions: [],
  allIOSAppVersions: []
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
